import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedSnackbar,
	IDNDList,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import { IGetListRequest, IResponse, IServerError } from "../../../../models/common";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { firstPanelDraggableId, secondPanelDraggableId } from "../../../CompanyStatutoryHolidaySetup";
import {
	scrollPanelFieldsToTop,
	sortDDLByLabel,
	sortDragDropContextDDLByText,
	useNavigateToLogout,
} from "../../../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AccountSettingsService } from "../../../../services/AddOns/Accounting/AccountSettingsService";
import { BasicTwoColumnLayoutShowOnlyTitleSetupToolbar } from "../../../BasicTwoColumnLayoutShowOnlyTitleSetupToolbar";
import { ClassLocatIonDepartmentInfoFieldsPanel } from "./Panels/ClassLocatIonDepartmentInfoFieldsPanel";
import { DepartmentsService } from "../../../../services/DepartmentsService";
import EmployeelistAndAssignedEmployeesPanel from "./Panels/EmployeeListAndAssignedEmployeesPanel";
import { IAppState } from "../../../../store/reducers";
import { IDropDownListResponse } from "../../../../models/common/IDropDownListResponse";
import { IManageWageAccount } from "../../../../models/AddOns/Accounting/ManageWageAccount";
import { IMoveItemsPayload } from "../../../DragDropDDLPanel";
import { LocationsService } from "../../../../services/LocationsService";
import { ManageWageAccountDDLTable } from "./ManageWageAccountDDLTable/ManageWageAccountDDLTable";
import { ManageWageAccountHeaderFieldsPanel } from "./Panels/ManageWageAccountHeaderInfoFieldsPanel";
import { ManageWageAccountService } from "../../../../services/AddOns/Accounting/ManageWageAccountService";
import { ManageWageAccountValidationSchema } from "./validator";
import { WSIBClassService } from "../../../../services/WSIBClassService";
import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../../store/actions/stickyNavBarActions";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IManageWageAccountSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "single-data-record";
const MANAGE_WAGE_ACCOUNT_LIST_DATA_QUERY_KEY = "minimumWageAccount-list";

const useManageWageAccountList = (
	runGetListAPICall: boolean,
	clientId: string,
	// params: IGetListRequest,
	wageAccountType: string,
	postingAccount: string,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [MANAGE_WAGE_ACCOUNT_LIST_DATA_QUERY_KEY, runGetListAPICall, clientId, wageAccountType,
			postingAccount],
		queryFn: (data) => {

			return ManageWageAccountService.getManageWageAccount(
				runGetListAPICall,
				clientId,
				// params,
				wageAccountType,
				postingAccount,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetWageAccountTypeDDL = (clientId: string) =>
	useQuery({
		queryKey: ["wage-account-type-ddl"],
		queryFn: (data) => {
			return ManageWageAccountService.getWageAccounTypeDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});

const getAccountSettingsDDL = (manageWageAccountPageName: string, clientId: string,) =>
	useQuery({
		queryKey: ["account-settings-ddl", manageWageAccountPageName, clientId],
		queryFn: (data) => {
			return AccountSettingsService.getAccountSettingsDDL(manageWageAccountPageName, clientId);
		},
		refetchOnWindowFocus: false,
	});


const useGetAssignedEligiblePanels = (
	manageWageAccountPageName: string,
	clientId: string,
	wageAccountType: string,
	postingAccount: string,
) =>
	useQuery({
		queryKey: ["assign-unassign-employees", manageWageAccountPageName, clientId, wageAccountType, postingAccount],
		queryFn: (data) => {

			return ManageWageAccountService.getEmployeeAssignUnassignmentDDL(manageWageAccountPageName, clientId, wageAccountType, postingAccount);
		},
		refetchOnWindowFocus: false,
		// enabled: false
	});

const useGetLocationsDDL = (clientId: string) =>
	useQuery({
		queryKey: ["locations-ddl", clientId],
		queryFn: () => {
			return LocationsService.getGetLocationsDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});

const useDepartmentsDDL = (
	clientId: string,
) =>
	useQuery({
		queryKey: ["departments-list"],
		queryFn: (data) => {

			return DepartmentsService.getGetDepartmentsDDL(
				clientId,
			);
		},
		refetchOnWindowFocus: false,
	});

const ussClassDDL = (
) =>
	useQuery({
		queryKey: ["wsib-class-ddl"],
		queryFn: (data) => {

			return WSIBClassService.getGetWSIBClassDDL();
		},
		refetchOnWindowFocus: false,
	});

export const ManageWageAccount: React.FC<IManageWageAccountSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const [isLoading, setIsLoading] = useState(false);
	const [wageAccountTypeLoadData, setWageAccountTypeLoadData] =
		useState<any>(undefined);
	const [runGetListAPICall, setRunGetListAPICall] =
		useState<any>(false);

	// Fucking combine component props defines here
	const { id, ManageWageAccountPageName } = useParams();

	// manageWageAccountPageName would be like 
	// net_suite
	// zoho_books
	// xero
	// quick_books

	const [manageWageAccountPageName, setManageWageAccountPageName] = useState<string>("");
	useEffect(() => {
		if (ManageWageAccountPageName && ManageWageAccountPageName.length > 0) {

			setManageWageAccountPageName(ManageWageAccountPageName);
			if (ManageWageAccountPageName !== manageWageAccountPageName) {
				// formMethods.reset();
			}
		}
	}, [manageWageAccountPageName, ManageWageAccountPageName]);

	const [editRecordId, setEditRecordId] = useState(id);

	const [firstList, setFirstList] = useState<IDNDList>({
		droppableId: "firstList",
		elements: [],
		testId: "firstList",
	});

	const [secondList, setSecondList] = useState<IDNDList>({
		droppableId: "secondList",
		elements: [],
		testId: "secondList",
	});

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const formMethods = useForm<any>({
		resolver: yupResolver(ManageWageAccountValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",

	});

	const wageAccountType = formMethods.watch("wageAccountType")
	const postingAccount = formMethods.watch("postingAccount")

	const {
		isLoading: isLoadingAssignedClients,
		data: assignedEligiblePanelResponsePayload,
		refetch: refetchAssignedEligiblePanels,
	} = useGetAssignedEligiblePanels(manageWageAccountPageName, clientId, wageAccountType, postingAccount);


	useEffect(() => {
		if (manageWageAccountPageName && clientId) {
			refetchAssignedEligiblePanels();
		}
	}, [manageWageAccountPageName, clientId, wageAccountType, postingAccount]);

	const { isLoading: isLoadingWageAccountTypeDDL, data: wageAccountTypeDDL } = useGetWageAccountTypeDDL(clientId);
	const { isPending: isPendingAccountSettings, data: accountSettingsDDL } = getAccountSettingsDDL(manageWageAccountPageName, clientId);
	const { isLoading: isLoadingLocations, data: locationsDDL } = useGetLocationsDDL(clientId);
	const { isLoading: isDepartmentLoadingDDL, data: departmentDDL } = useDepartmentsDDL(clientId);
	const { data: wsibClassSetupDDL, isLoading: isClassDDLLoading } = ussClassDDL();

	const { isPending, data } = useManageWageAccountList(runGetListAPICall, clientId,
		wageAccountType,
		postingAccount,
		navigateToLogout);
	const manageWageAccountList: any | null = data;

	useEffect(() => {
		if (manageWageAccountList) {
			setWageAccountTypeLoadData(manageWageAccountList);
		}
	}, [manageWageAccountList]);

	const upadtedManageWageAccountListItems = useMemo(() => {
		return (
			wageAccountTypeLoadData &&
			wageAccountTypeLoadData.items &&
			wageAccountTypeLoadData?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/add-ons/manage-wage-account/${manageWageAccountPageName}/${clientId}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{item.wageAccountType}

					</Link>
				),

			}))
		);
	}, [wageAccountTypeLoadData]);

	const wageAccountTypeDDLItems = useMemo(() => {
		if (wageAccountTypeDDL) {
			if (
				wageAccountTypeDDL &&
				Array.isArray(wageAccountTypeDDL)
			) {
				let resources: IDropDownListResponse[] =
					sortDDLByLabel(wageAccountTypeDDL).map(
						(resourceItem: IDropDownListResponse) => ({
							// id: resourceItem.id,
							label: resourceItem.label,
							value: resourceItem.value,
						})
					);

				resources.unshift({
					label: "All",
					value: "all",
				});

				return resources;
			}
			return [];
		}
	}, [wageAccountTypeDDL]);

	const postingAccountDDLItems = useMemo(() => {
		if (accountSettingsDDL) {
			if (
				accountSettingsDDL &&
				Array.isArray(accountSettingsDDL)
			) {
				let resources: IDropDownListResponse[] =
					sortDDLByLabel(accountSettingsDDL).map(
						(resourceItem: IDropDownListResponse) => ({
							// id: resourceItem.id,
							label: resourceItem.label,
							value: resourceItem.value,
						})
					);

				resources.unshift({
					label: "All",
					value: "all",
				});

				return resources;
			}
			return [];
		}
	}, [accountSettingsDDL]);

	const formatLabel = (key: string) => {
		return key
			.replace(/([a-z])([A-Z])/g, "$1 $2")
			.replace(/accounts?$/i, " Accounts")
			.replace(/[_-]+/g, " ")
			.replace(/\s+/g, " ")
			.trim()
			.toLowerCase()
			.replace(/\b\w/g, (c) => c.toUpperCase());
	}
	const extractGroups = (source: Record<string, any>) => {
		const groups: any = [];

		Object.entries(source).forEach(([key, value]) => {
			if (Array.isArray(value)) {
				groups.push({
					label:
						key === "DIRECTCOSTS" ? "DIRECT COSTS" :
							key === "CURRLIAB" ? "CURRENT LIABILITY" :
								key === "TERMLIAB" ? "TERM LIABILITY" :
									formatLabel(key),
					slug: key,
					value: key,
					options: value,
				});
			} else if (value && typeof value === "object") {
				Object.entries(value).forEach(([nestedKey, nestedValue]) => {
					if (Array.isArray(nestedValue)) {
						groups.push({
							label: formatLabel(nestedKey),
							slug: nestedKey,
							value: nestedKey,
							options: nestedValue,
						});
					}
				});
			}
		});

		return groups;
	}

	const updateAccountSettingsDDLWithParentChildDDL = useMemo(() => {
		if (accountSettingsDDL && accountSettingsDDL.allaccounts) return extractGroups(accountSettingsDDL.allaccounts);
	}, [accountSettingsDDL]);

	//   after click apply button api calls with updated values and update wage account data
	const wageAccountLoadDataAPICall = (
		wageAccountType: string,
		postingAccount: string,
	) => {
		const fetchData = async () => {
			setIsLoading(true);

			try {
				const response: any = await ManageWageAccountService.getManageWageAccount(
					true,
					clientId,
					wageAccountType,
					postingAccount,
					navigateToLogout
				);
				if (response) {
					setWageAccountTypeLoadData(response);
				}
			} catch (error) {
				console.error(error);
			} finally {
				setIsLoading(false);
			}
		};
		fetchData();
	};

	const onSubmit = (values: any) => {
		wageAccountLoadDataAPICall(
			values.wageAccountType,
			values.postingAccount,
		);
	};

	const { isPending: isPendingBulkDrag, mutate: assignUnassignMultipleEmployee } = useMutation({
		mutationFn: ManageWageAccountService.AssignUnassignMultipleEmployee,
		onSuccess: (res: IServerError | IResponse | null | any) => {
			if (res?.status === true) {
				setSnackbarData({
					open: true,
					message:
						"Employee(s) has been assigned to the Eligibility panel successfully",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message:
						"Employee(s) has been unassigned from the Eligibility panel successfully",
					severity: "warning",
				});
			}
			refetchAssignedEligiblePanels();
		},
		onError: (err) => {
			setSnackbarData({
				open: true,
				message: "An error occurred, please try again",
				severity: "error",
			});
		},
	});


	useEffect(() => {
		if (
			assignedEligiblePanelResponsePayload &&
			assignedEligiblePanelResponsePayload) {
			let assignedEmployees: IDNDList = {
				droppableId: firstPanelDraggableId,
				elements: sortDragDropContextDDLByText(assignedEligiblePanelResponsePayload.assignedEmployees).map(
					(assignedEmployeesFlexField: any) => ({
						id: String(assignedEmployeesFlexField.id),
						text: String(assignedEmployeesFlexField.text),
						value: String(assignedEmployeesFlexField.value),
					})
				),
				testId: firstPanelDraggableId,
			};

			let unAssignedEmployees: IDNDList = {
				droppableId: secondPanelDraggableId,
				elements: sortDragDropContextDDLByText(assignedEligiblePanelResponsePayload.unAssignedEmployees).map(
					(unAssignedEmployeesFlexField: any) => ({
						id: String(unAssignedEmployeesFlexField.id),
						text: String(unAssignedEmployeesFlexField.text),
						value: String(unAssignedEmployeesFlexField.value),
					})
				),
				testId: secondPanelDraggableId,
			};
			setFirstList(assignedEmployees);
			setSecondList(unAssignedEmployees);
		}

	}, [assignedEligiblePanelResponsePayload]);

	const onListsChange = useCallback(
		(updatedFirstList: IDNDList, updatedSecondList: IDNDList) => {
			setFirstList(updatedFirstList);
			setSecondList(updatedSecondList);
		},
		[]
	);
	const onMoveItems = useCallback(
		(payload: IMoveItemsPayload) => {
			// moving into secondList => flag false (ineligible), into firstList => flag true (eligible)
			const flag = payload.destinationDroppableId === secondPanelDraggableId;

			if (payload.isBulk) {
				assignUnassignMultipleEmployee({
					employeeIds: payload.movedItemIds,
					flag: !flag,
					clientId: clientId,
					wageAccountType: wageAccountType,
					postingAccount: postingAccount,
				});
			} else {
				assignUnassignMultipleEmployee({
					employeeIds: [payload.movedItemIds[0]],
					flag: !flag,
					clientId: clientId,
					wageAccountType: wageAccountType,
					postingAccount: postingAccount,
				});
			}
			console.log("wageAccountType", wageAccountType)
		},
		[assignUnassignMultipleEmployee, wageAccountType, postingAccount]
	);

	console.log("wageAccountTypeBhair", wageAccountType)
	const { isPending: isDeleting, mutate: deleteManageWageAccountById } = useMutation({
		mutationFn: ManageWageAccountService.delManageWageAccount,
		onSuccess: (res: string | IServerError | IResponse | any) => {
			if (typeof res === "string") {

				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.status === false ? "error" : res.success === false ? "error" : "success",
				});
			}
			formMethods.reset();
			scrollPanelFieldsToTop();
			let path = `/add-ons/manage-wage-account/${manageWageAccountPageName}`;
			navigate(path);
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});


	const deleteManageWageAccountField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				manageWageAccountPageName: manageWageAccountPageName,
				clientId: clientId,
				navigateToLogout: navigateToLogout,
			}
			deleteManageWageAccountById(delPayload);
			setDialogOpen(false);
		}
	};

	const expandedLabels = ["Add-Ons"];
	const enhanceData = (data: any[], ancestorChain: string[] = []): any[] => {
		return data.map((item) => {
			const currentChain = [...ancestorChain, item.label];

			const isAccounting =
				item.label === "Accounting" &&
				ancestorChain.includes("Add-Ons");

			// Any integration under Accounting (Zoho Books, Xero, Sage, etc.)
			const isAccountingIntegration =
				item.items &&
				ancestorChain.includes("Add-Ons") &&
				ancestorChain.includes("Accounting");

			// Leaf node: Account Settings
			const isAccountSettings =
				item.label === "Manage Wage Account" &&
				ancestorChain.includes("Add-Ons") &&
				ancestorChain.includes("Accounting");

			const isExpanded =
				expandedLabels.includes(item.label) ||
				isAccounting ||
				isAccountingIntegration;

			return {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items
					? enhanceData(item.items, currentChain)
					: undefined,
				path: isAccountSettings
					? `/add-ons/manage-wage-account/${manageWageAccountPageName}`
					: item.path ?? undefined,
			};
		});
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	useEffect(() => {
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	return (
		<>
			<Grid>
				<BackdropCircularProgress
					open={
						// isSubmitting ||
						isLoading ||
						// isPendingById ||
						isDeleting || isLoadingWageAccountTypeDDL || isPendingAccountSettings || isLoadingLocations || isDepartmentLoadingDDL || isClassDDLLoading
					}
					testId="manage-wage-account"
				/>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={deleteManageWageAccountField}
					cancelActionHandler={onCloseHandler}
					testId="manage-wage-account-confirmation-dialog"
				/>
				<BasicTwoColumnLayoutShowOnlyTitleSetupToolbar
					pageTitle={"Manage Wage Account"}
				/>
				<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<FormProvider {...formMethods}>
							<form onSubmit={formMethods.handleSubmit(onSubmit)}>
								<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
									<Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ background: "#fff", border: "1px solid rgba(0, 0, 0, 0.12)" }}>
										<StandardPanel
											title=""
											testId={``}
											variant="outlined"
											borderBottom={true}
											borderHide={true}
											showTitle={false}
										>
											<ManageWageAccountHeaderFieldsPanel
												testId={"manage-wage-account-header"}
												wageAccountTypeDDL={wageAccountTypeDDLItems}
												postingAccountDDL={accountSettingsDDL && updateAccountSettingsDDLWithParentChildDDL}
											/>
										</StandardPanel>
										<EmployeelistAndAssignedEmployeesPanel
											firstList={firstList}
											secondList={secondList}
											onListsChange={onListsChange}
											onMoveItems={onMoveItems}
											isLoading={isLoadingAssignedClients || isPendingBulkDrag}
										/>
										<StandardPanel
											title=""
											testId={``}
											variant="outlined"
											borderBottom={true}
											borderHide={true}
											showTitle={false}
										>
											<>
												<ClassLocatIonDepartmentInfoFieldsPanel
													classDDL={wsibClassSetupDDL && sortDDLByLabel(wsibClassSetupDDL)}
													locationDDL={locationsDDL && sortDDLByLabel(locationsDDL)}
													departmentDDL={departmentDDL && sortDDLByLabel(departmentDDL)}
													testId={""}
												/>
											</>
										</StandardPanel>
									</Grid>
									<Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}></Grid>
									<Grid
										size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}
										sx={{ marginTop: "4px" }}>
										<ManageWageAccountDDLTable
											rows={
												wageAccountTypeLoadData && upadtedManageWageAccountListItems
													? upadtedManageWageAccountListItems
													: []

												// wageAccountTypeLoadData?.items ?? []
											}
											columns={[
												{ field: "label", headerName: "Account Type" },
												{ field: "postingAccount", headerName: "Posting Account" },
												{ field: "totalEmployees", headerName: "Total Employees" },

											]}
											showHeaderColumns={true}
											// onRowEditClicked={onRowEditClicked}
											// onRowDeleteClicked={onRowDeleteClicked}
											// onRowArchiveClicked={onArchiveClicked}
											showArchiveIcon={false}
											showDeleteIcon={false}
											showPaginator={false}
											// showIndexColumn={true}
											isLoading={isPending}
											totalRecords={
												wageAccountTypeLoadData && wageAccountTypeLoadData.total
													? wageAccountTypeLoadData.total
													: 0
											}
											initialPageSize={INITIAL_PAGE_SIZE}
											rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
											onRequestParamsChange={onRequestParamsChange}
											tableScrollHeight={"60vh"}
											selectedId={""}
										/>
									</Grid>
									<Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}></Grid>
								</Grid>
							</form>
						</FormProvider>

					</Grid>
				</Grid>
				<EnhancedSnackbar
					message={snackbarData.message}
					onCloseHandler={onSnackbarClosed}
					severity={snackbarData.severity}
					testId={"manage-wage-account-snackbar"}
					open={snackbarData.open}
				/>
			</Grid>
		</>
	);
};
